/** Dog mascot logo plus dealer.dog wordmark. */
export function DealerDogBrand() {
  return (
    <>
      <img src="/logo.png" alt="DealerDog" className="brand-logo" />
      <span aria-hidden="true">
        dealer<span className="brand-dot">.</span>dog
      </span>
    </>
  );
}
